import { useEffect as $ } from "react";
const P = (s, t, w) => {
  const e = w ? "flash-message" : "toast";
  $(() => {
    var o, y, r, d, m, p, i, n, l, b, g, f, u, v;
    s[0] === "bottom" ? ((o = document.body) == null || o.style.setProperty(`--design-system-${e}-set-viewport-bottom`, "0"), (y = document.body) == null || y.style.setProperty(
      `--design-system-${e}-set-viewport-top`,
      "unset"
    )) : ((r = document.body) == null || r.style.setProperty(`--design-system-${e}-set-viewport-top`, "0"), (d = document.body) == null || d.style.setProperty(
      `--design-system-${e}-set-viewport-bottom`,
      "unset"
    )), s[1] === "right" && ((m = document.body) == null || m.style.setProperty(`--design-system-${e}-set-viewport-right`, "0"), (p = document.body) == null || p.style.setProperty(
      `--design-system-${e}-set-viewport-left`,
      "unset"
    ), (i = document.body) == null || i.style.setProperty(
      `--design-system-${e}-set-viewport-align-items`,
      "flex-end"
    )), s[1] === "left" && ((n = document.body) == null || n.style.setProperty(`--design-system-${e}-set-viewport-left`, "0"), (l = document.body) == null || l.style.setProperty(
      `--design-system-${e}-set-viewport-right`,
      "unset"
    ), (b = document.body) == null || b.style.setProperty(
      `--design-system-${e}-set-viewport-align-items`,
      "flex-start"
    )), t && ((g = document.body) == null || g.style.setProperty(
      `--design-system-${e}-set-viewport-top`,
      t.top
    ), (f = document.body) == null || f.style.setProperty(
      `--design-system-${e}-set-viewport-bottom`,
      t.bottom
    ), (u = document.body) == null || u.style.setProperty(
      `--design-system-${e}-set-viewport-left`,
      t.left
    ), (v = document.body) == null || v.style.setProperty(
      `--design-system-${e}-set-viewport-right`,
      t.right
    ));
  }, [t, e, s]);
};
export {
  P as usePrimitiveToastPosition
};
//# sourceMappingURL=index.es5485.js.map
